import moment, { Moment } from 'moment';
import { defineComponent, PropType } from 'vue';
import { NEllipsis, NTooltip } from 'naive-ui';

import { Station } from '~/api/models/station.model';

import ComponentBase from '~/components/component-base';

// import { AvoltaAlarmEnum } from '~/configs/alarms/avolta-alarm.model';
// import { AvoltaAlarmMapping, AvoltaAlarmConfiguration } from '~/configs/alarms/avolta-alarm.config';
import { AvoltaAlarm } from '~/configs/alarms/avolta-alarm.model';
import { AvoltaCH4Indicator, AvoltaHumidityIndicator, AvoltaTemperatureIndicator } from '~/configs/indicators/avolta-indicators.config';
import { getStationAlarms, isStationInGasAlarm, isStationInTrouble, isStationOffline } from '~/misc/station-utils';
import { orangeColor, redColor } from '~/variables';
/**
 * Configuration for one value of network quality. Network quality goes from -2 to 4.
 */
export interface NetworkIndicator {
    /**
     * Actual value
     */
    value: number;

    /**
     * Icon representation
     */
    icon: string;

    /**
     * Label representation
     */
    label: string;

    /**
     * 
     */
    color?: string;

    /**
     * tooltip of value
     */
    tooltip: string;
}


export default defineComponent({

    extends: ComponentBase,

    components: {
        NTooltip,
        NEllipsis,
    },

    data() {
        return {
            AvoltaCH4Indicator,
            AvoltaTemperatureIndicator,
            AvoltaHumidityIndicator,
            moment,

            redColor,
            orangeColor,

            networkRepresentation: {
                '-1': { value: -2, icon: 'elichens-avolta elichens-signal-0', label: this.$t('global.network.offline'), tooltip: ''},
                '0': { value: -2, icon: 'elichens-avolta elichens-signal-1', label: this.$t('global.network.very_poor'), tooltip: ''},
                '1': { value: -2, icon: 'elichens-avolta elichens-signal-2', label: this.$t('global.network.poor'), tooltip: ''},
                '2': { value: -2, icon: 'elichens-avolta elichens-signal-2', label: this.$t('global.network.average'), tooltip: ''},
                '3': { value: -2, icon: 'elichens-avolta elichens-signal-3', label: this.$t('global.network.good'), tooltip: ''},
                '4': { value: -2, icon: 'elichens-avolta elichens-signal-4', label: this.$t('global.network.very_good'), tooltip: ''},
            } as {[value: number]: NetworkIndicator }
        }
    },

    props: {
        device: { type: Object as PropType<Station> },
        since: { type: Object as PropType<Moment> },
        before: { type: Object as PropType<Moment> },
        showStatus: { type: Boolean , default: true },
    },

    computed: {

        alarms(): AvoltaAlarm[] {
            return getStationAlarms(this.device).filter(a => a?.name !== 'offline');
        },

        hasGasAlarm(): boolean {
            return isStationInGasAlarm(this.device);
        },

        hasTroubleAlarm(): boolean {
            return isStationInTrouble(this.device);
        },

        isDeviceOffline(): boolean {
            return isStationOffline(this.device);
        },

        network(): NetworkIndicator {
            const network = this.device.status === 'offline' ? -1 : this.device?.latest_values['network_quality'];
            return this.networkRepresentation[network];
        },

        backgroundColor(): string {
            if(this.hasGasAlarm) {
                return 'has-bg-danger';
            } else if(this.isDeviceOffline || this.hasGasAlarm) {
                return 'has-bg-warning';
            } else {
                return '';
            }
        }
    }
});